export function getUserSettings(
  data,
  { defaultFilters } = { defaultFilters: () => {} },
) {
  return data && data.userSettings
    ? {
        columnsMapping: data.userSettings.columns,
        frozenColumns: data.userSettings.frozenColumns,
        groups: data.userSettings.groups,
        sorting: data.userSettings.sorting,
        accountType: data.userSettings.accountType,
        repCode: data.userSettings.repCode,
        filterDefinition: {
          ...defaultFilters(data.userSettings),
          ...data.userSettings.filterDefinition,
        },
      }
    : {
        filterDefinition: defaultFilters({}),
      };
}

export function getDefaultUserSettings(dataGrid) {
  return {
    defaultColumns: dataGrid.defaultColumns,
    defaultGroupPanels: dataGrid.defaultGroupPanels.groups,
    defaultSorting: dataGrid.defaultSorting.sorting.map(sortObject => ({
      ascending: sortObject.ascending,
      property: sortObject.property
    }))
  }
}
